import type { ReactNode } from 'react';
import { Layout } from 'react-admin';
import { RegionProvider } from '../auth/RegionContext';
import { ImpersonationProvider } from '../impersonation/ImpersonationContext';
import { AdminAppBar } from './AppBar';
import { AppMenu } from './AppMenu';

/**
 * App layout: wraps React Admin's <Layout> in the <RegionProvider> so the
 * region context is available to the top bar, the menu and every page (route
 * guards), and in the <ImpersonationProvider> so the persistent "viewing as"
 * indicator and the member's-eye view share one active-session source across
 * every route. Installs the custom top bar (region switcher + impersonation
 * indicator) and the access-gated sidebar menu. Persistent across all routes.
 */
export const AppLayout = ({ children }: { children: ReactNode }) => (
  <RegionProvider>
    <ImpersonationProvider>
      <Layout appBar={AdminAppBar} menu={AppMenu}>
        {children}
      </Layout>
    </ImpersonationProvider>
  </RegionProvider>
);
